import { WebStoragesKeys } from '@/shared/enums/webStorages';
import { WebStorageAccessor } from '@stores/webStorages/lib/WebStorageAccessor';

export class PersistedFeatureFlagsAccessor extends WebStorageAccessor {
  getPersistedFlags() {
    return this.parse<Record<string, boolean>>();
  }

  persistFlags(flags: Record<string, boolean>) {
    this.stringify(flags);
  }
}

export const persistedFeatureFlagsAccessor: PersistedFeatureFlagsAccessor = new PersistedFeatureFlagsAccessor(
  sessionStorage,
  WebStoragesKeys.FFLAGS,
);
